/**
 * Purpose: Credit decision related selectors only.
 */

// utils
import type { ICreditDecisionLender } from '@makemydeal/dr-platform-types';
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import {
    getCreditDecisionDetails,
    getCreditDecisionLenderByOfferType,
    getCreditDecisionLenderNameByOfferType,
    getCreditDecisionStatusByOfferType,
    getCurrentOfferType
} from './offerNodeSelectors';

// start automated Decisions Selectors
export const getMonthlyPaymentFromDecisionDetails = (state: OfferReduxBaseState): number | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.calculatedMonthlyPayment ?? null;
};

export const getAPRFromDecisionDetails = (state: OfferReduxBaseState): number => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.approvedRate ?? 0;
};

export const getTermFromDecisionDetails = (state: OfferReduxBaseState): number | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.approvedTerm ?? null;
};

export const getDownPaymentFromDecisionDetails = (state: OfferReduxBaseState): number | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.downPayment ?? null;
};

export const getApprovedAmountFromDecisionDetails = (state: OfferReduxBaseState): number | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.approvedAmount ?? null;
};

export const getLenderIdFromDecisionDetails = (state: OfferReduxBaseState): string | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.lenderId ?? null;
};

export const getLenderNameFromDecisionDetails = (state: OfferReduxBaseState): string | null => {
    const decisionDetails = getCreditDecisionDetails(state);
    return decisionDetails.lenderName ?? null;
};
// Ends automated Decisions Selectors

// TODO Delete getCreditDecisionLenderName after feature toggle enableAppliedLenderInfo has been deleted
export const getCreditDecisionLenderName = (state: OfferReduxBaseState): string | undefined => {
    const offerType = getCurrentOfferType(state);
    return getCreditDecisionLenderNameByOfferType(state, offerType);
};

export const getCreditDecisionLender = (state: OfferReduxBaseState): ICreditDecisionLender | undefined => {
    const offerType = getCurrentOfferType(state);
    return getCreditDecisionLenderByOfferType(state, offerType);
};

export const getCreditDecisionStatus = (state: OfferReduxBaseState): string | undefined => {
    const offerType = getCurrentOfferType(state);
    return getCreditDecisionStatusByOfferType(state, offerType);
};
